<template>
  <div class="adm-layout">
    <Sidebar />
    <HeaderPartial />
    <main class="adm-layout__content" :style="{ '--sb-w': sidebarWidth }">
      <router-view></router-view>
    </main>
  </div>
</template>

<script>
import Sidebar from "../sidebar/Sidebar.vue";
import HeaderPartial from "../partials/HeaderAdmin.partial.vue";
import { sidebarWidth } from "../sidebar/state";

export default {
  components: {
    Sidebar,
    HeaderPartial,
  },
  setup() {
    return { sidebarWidth };
  },
};
</script>

<style scoped>
.adm-layout {
  min-height: 100vh;
  background: #eef2f7;
}

.adm-layout__content {
  padding-top: 60px; /* header height */
  min-height: 100vh;
  box-sizing: border-box;
  background: #eef2f7;
}

@media (min-width: 1024px) {
  .adm-layout__content {
    margin-left: var(--sb-w, 252px);
    transition: margin-left 0.16s cubic-bezier(0.4, 0, 0.2, 1);
    will-change: margin-left;
  }
}
</style>
